import { render, staticRenderFns } from "./base_snackbar.vue?vue&type=template&id=e56f5ad0&scoped=true&"
import script from "./base_snackbar.vue?vue&type=script&lang=ts&"
export * from "./base_snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./base_snackbar.vue?vue&type=style&index=0&id=e56f5ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56f5ad0",
  null
  
)

export default component.exports